<template>
    <v-row class="row--xs">
        <v-col cols="12" lg="6">
            <v-card rounded color="grey lighten-5" class="pa-5 h-100">
                <v-row justify="space-between" align="center">
                    <v-col cols="auto">
                        <div class="txt txt--xs">재고현황</div>
                    </v-col>
                    <v-col cols="auto">
                        <div class="txt txt--lg txt--dark font-weight-bold d-flex align-center">{{ summary?.entireAmount?.format?.() || 0 }}<span class="txt--xs ml-2px">개</span></div>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
        <v-col cols="12" lg="6">
            <v-card rounded color="grey lighten-5" class="pa-5 h-100">
                <v-row justify="space-between" align="center">
                    <v-col cols="auto">
                        <div class="txt txt--xs">총액</div>
                    </v-col>
                    <v-col cols="auto">
                        <div class="txt txt--lg primary--text font-weight-bold d-flex align-center">{{ summary?.overallPrice?.format?.() || 0 }}<span class="txt--xs ml-2px">원</span></div>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        summary: { type: Object, default: () => ({ totalCount: 0, entireAmount: 0, overallPrice: 0 }) },
    },
};
</script>
